import React from 'react';
import { 
  HiOutlineChartBar, 
  HiOutlineBolt, 
  HiOutlineArrowsRightLeft 
} from 'react-icons/hi2';

// Feature Card Component
const FeatureCard = ({ icon: Icon, title, description, iconColor, bgColor }) => {
  return (
    <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 hover:shadow-lg hover:border-gray-200 transition-all duration-300 group">
      {/* Icon Container */}
      <div className={`w-16 h-16 rounded-full ${bgColor} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
        <Icon className={`w-8 h-8 ${iconColor}`} />
      </div>
      
      {/* Content */}
      <h3 className="text-xl font-bold text-gray-900 mb-4 font-heading">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed font-sans">
        {description}
      </p>
    </div>
  );
};

// Main FeaturesSection Component
const FeaturesSection = () => {
  const features = [
    {
      icon: HiOutlineChartBar,
      title: "Long-Term Reversals",
      description: "Identify undervalued stocks at the brink of a major turnaround. Our algorithm pinpoints assets with strong fundamentals poised for long-term growth.",
      iconColor: "text-green-500",
      bgColor: "bg-green-50"
    },
    {
      icon: HiOutlineBolt,
      title: "Short-Term Momentum",
      description: "Capitalize on market trends. We analyze real-time data to find stocks with strong upward momentum, perfect for short-term gains and active trading.",
      iconColor: "text-blue-500",
      bgColor: "bg-blue-50"
    },
    {
      icon: HiOutlineArrowsRightLeft,
      title: "Swing Trading Setups",
      description: "Master the market's ebb and flow. Our system detects high-probability breakout opportunities based on volatility and RSI, giving you a clear edge in swing trading.",
      iconColor: "text-orange-500",
      bgColor: "bg-orange-50"
    }
  ];

  return (
    <section className="py-20" style={{ backgroundColor: '#f5f6f8' }}>
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-heading">
            Find Stocks <span className="bg-gradient-to-r from-green-600 to-cyan-600 bg-clip-text text-transparent">
            in Minutes
          </span>, Not Hours
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-sans">
            Our triple-algorithm approach scans thousands of stocks to deliver clear, actionable signals for any trading style.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              iconColor={feature.iconColor}
              bgColor={feature.bgColor}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
